export const Bio = {
  name: "M. Suleman",
  roles: ["Full Stack Developer", "UI Developer", "Problem Solver"],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/sulesuleman",
  resume:
    "https://drive.google.com/file/d/1McCAku3u5sp8dunPhwiL-JWlVONyHNgk/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/sulesuleman/",
  // twitter: "https://twitter.com/RishavChanda",
  // insta: "https://www.instagram.com/rishav_chanda/",
  // facebook: "https://www.facebook.com/rishav.chanda.165/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML5",
        image: "/assets//skills/html.png",
      },
      {
        name: "CSS3",
        image: "/assets//skills/css.png",
      },
      {
        name: "JavaScript",
        image: "/assets/skills/js.png",
      },
      {
        name: "React Js",
        image: "/assets/skills/react.png",
      },
      {
        name: "Redux",
        image: "/assets/skills/redux.png",
      },
      {
        name: "Next Js",
        image: "/assets/skills/next.png",
      },
      {
        name: "Material UI",
        image: "/assets/skills/mui.png",
      },
      {
        name: "TailwindCSS",
        image: "/assets/skills/tailwind.png",
      },
      {
        name: "TypeScript",
        image: "/assets/skills/ts.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },

      {
        name: "React Query",
        image: "/assets/skills/reactquery.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "/assets/skills/node-js.png",
      },
      {
        name: "Express Js",
        image: "/assets/skills/express.png",
      },
      {
        name: "Graph Ql",
        image: "/assets/skills/graphql.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image: "/assets/skills/mysql.png",
      },
      {
        name: "Postgresql",
        image: "/assets/skills/postger.png",
      },
      {
        name: "MongoDB",
        image: "/assets/skills/mongodb.png",
      },
      {
        name: "Firebase",
        image: "/assets/skills/firebase.png",
      },
      {
        name: "Stripe",
        image: "/assets/skills/stripe.webp",
      },
    ],
  },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: "/assets/skills/git.png",
      },
      {
        name: "GitHub",
        image: "/assets/skills/gitwhite.png",
      },
      {
        name: "GitLab",
        image: "/assets/skills/gitlab.png",
      },
      {
        name: "React Native",
        image: "/assets/skills/react-native.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image: "/assets/skills/postman.png",
      },
      {
        name: "Adobe XD",
        image: "/assets/skills/adobe.png",
      },
      {
        name: "Figma",
        image: "/assets/skills/figma.png",
      },
    ],
  },
];

export const experiences = [
  //   {
  //     id: 0,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
  //     role: "DevOps & Fullstack Engineering Intern",
  //     company: "Flipr Inovations Pvt. Ltd.",
  //     date: "Aug 2023 - July 2023",
  //     desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
  //     skills: [
  //       "Docker",
  //       "Terraform",
  //       "AWS",
  //       "EC2",
  //       "Portainer",
  //       "Nginx",
  //       "JavaScript",
  //       "TypeScript",
  //       "Node Js",
  //       " Next Js",
  //     ],
  //     doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  //   },
  //   {
  //     id: 0,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
  //     role: "Frontend Engineer Intern",
  //     company: "Neurobit",
  //     date: "June 2023 - Present",
  //     desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
  //     skills: [
  //       "ReactJS",
  //       "Redux",
  //       "NodeJs",
  //       "Material UI",
  //       "HTML",
  //       "CSS",
  //       "JavaScript",
  //     ],
  //     doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  //   },
  //   {
  //     id: 1,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
  //     role: "Fullstack Externship",
  //     company: "Flipr",
  //     date: "June 2023 - July 2023",
  //     desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
  //     skills: [
  //       "ReactJS",
  //       "Redux",
  //       "NodeJs",
  //       "Material UI",
  //       "HTML",
  //       "CSS",
  //       "JavaScript",
  //       "Docker",
  //       "AWS",
  //       "MongoDB",
  //     ],
  //   },
  //   {
  //     id: 2,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
  //     role: "Open Source Contributor ",
  //     company: "GirlScript Summer of Code",
  //     date: "May 2023 - Present",
  //     desc: "Contributing to different open-source projects and learn from industry experts",
  //     doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
  //   },
  //   {
  //     id: 3,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
  //     role: "Android Developer",
  //     company: "DSC KIIT",
  //     date: "Nov2021 - Present",
  //     desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
  //     skills: [
  //       "Leadership",
  //       "Mobile Application Development",
  //       "Kotlin",
  //       "XML",
  //       "Figma",
  //     ],
  //   },
  //   {
  //     id: 4,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
  //     role: "Android Developer Intern",
  //     company: "Rudraksha Welffare Foundation",
  //     date: "June 2021 - Oct 2021",
  //     desc: "As an Android Developer Intern at Rudraksha Welfare Foundation from June 2021 to October 2021, I gained valuable hands-on experience in application development. During my tenure, I contributed to the development of the application's back-end cloud functions using Firebase and implemented a front-end with the MVVM structure, which was designed using Figma. I also added a one-to-one video call feature, conceptualized new features, and optimized app performance. This internship helped me enhance my skills in Android development and gave me an opportunity to work in a collaborative team environment.",
  //     skills: [
  //       "Android",
  //       "Java",
  //       "Kotlin",
  //       "XML",
  //       "Node Js",
  //       "Cloud Firestore",
  //       "Firebase",
  //       "Figma",
  //     ],
  //     doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  //   },
  // ];
  // export const education = [
  //   {
  //     id: 0,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Kiit.jpeg?alt=media&token=3839d520-c59d-4341-ad8f-0980c98de4dd",
  //     school: "Kalinga Institute of Industrial Technology, Bhubaneswar",
  //     date: "Oct 2021 - Sep 2025",
  //     grade: "8.71 CGPA",
  //     desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Kalinga Institute of Industrial Technology, Bhubaneswar. I have completed 4 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
  //     degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  //   },
  //   {
  //     id: 1,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
  //     school: "Methodist School, Dankuni",
  //     date: "Apr 2019 - Apr 2025",
  //     grade: "88.2%",
  //     desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
  //     degree: "ISC(XII), Science with Computer",
  //   },
  //   {
  //     id: 2,
  //     img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
  //     school: "Methodist School, Dankuni",
  //     date: "Apr 2017 - Apr 2019",
  //     grade: "92.3%",
  //     desc: "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
  //     degree: "ICSC(X), Science with Computer",
  //   },
  // ];
];
export const projects = [
  {
    id: 0,
    title: "Sumedia",
    date: "Nov 2024 - Feb 2025",
    description:
      "I built the complete careers platform for VDK Groep — a large-scale, fully responsive website designed to attract top talent and reflect the company’s scale. It features job listings, team stories, employee benefits, and a streamlined application flow — all crafted for a smooth and engaging user experience.",
    images: [
      "/assets/projects/sumedia/banner.png",
      "/assets/projects/sumedia/carousel.png",
      "/assets/projects/sumedia/mapbox.png",
    ],
    tags: [
      "HTML5",
      "CSS3",
      "Javascript",
      "SCSS",
      "Mapbox",
      "GitLab",
      "Prettier",
      "EsLint",
      "Figma",
    ],
    category: "web app",
    github: null,
    href: "https://werkenbijvdkgroep.com/",
  },
  {
    id: 1,
    title: "Onestream Live",
    date: "Oct 2023 - Jul 2024",
    description:
      "OneStream Live is an innovative cloud-based live streaming platform that enables users to create professional-quality streams while broadcasting simultaneously to over 45 social media channels and websites. Combining an intuitive website, studio, and mobile app, OneStream Live offers a user-centric experience with seamless integration between frontend design and backend functionality. This powerful and flexible solution empowers content creators to effortlessly reach broader audiences and enhance their streaming capabilities across diverse platforms.",
    images: [
      "/assets/projects/osl/studio.png",
      "/assets/projects/osl/embed-settings.png",
      "/assets/projects/osl/destinations.png",
      "/assets/projects/osl/pre-rec.png",
      "/assets/projects/osl/theme-modes.png",
    ],
    tags: [
      "React Js",
      "Node Js",
      "Express Js",
      "mySQL",
      "Redux",
      "Sagas",
      "GitLab",
      "Docker",
      "Prettier",
      "Eslint",
      "Figma",
      "Axios",
      "MaterialUI",
      "Styled Components",
      "Nodemailer",
    ],
    category: "web app",
    github: null,
    href: "https://app.onestream.live/login",
  },
  {
    id: 2,
    title: "Small World Social Travel",
    date: null,
    description:
      "Social Travel is a dynamic travel platform designed to connect travelers, enabling them to share experiences, plan trips, and discover new destinations. The website features an engaging user interface that integrates social networking capabilities with travel planning tools, making it easy for users to create and customize travel itineraries, find recommendations, and interact with like-minded travelers. Built with a focus on community engagement, Social Travel serves as a one-stop solution for travel enthusiasts, offering seamless navigation, responsive design, and an intuitive experience across all devices.",
    images: [
      "/assets/projects/small-world-travels/hero.png",
      "/assets/projects/small-world-travels/about.png",
      "/assets/projects/small-world-travels/trips.png",
      "/assets/projects/small-world-travels/details.png",
    ],
    tags: [
      "React Js",
      "Node Js",
      "Express Js",
      "Strapi V4",
      "GitHub",
      "Prettier",
      "Eslint",
      "Axios",
      "Bootstrap",
    ],
    category: "web app",
    github: null,
    href: "https://www.socialtravel.world/",
  },
  {
    id: 3,
    title: "The Coterie",
    date: null,
    description:
      "The Coterie is a digital platform designed to streamline private fund management for both General Partners (GPs) and Limited Partners (LPs). It provides a comprehensive suite of tools for end-to-end investment management, simplifying processes like capital calls, fund performance tracking, and document handling. The platform offers a seamless experience, automating tasks and providing an intuitive interface for better transparency and efficiency in managing private investments​.",
    images: [
      "/assets/projects/coterie/elevating-private-funds.png",
      "/assets/projects/coterie/never-login-into-portal.png",
    ],
    tags: [
      "Next.Js 13",
      "GitHub",
      "Prettier",
      "Eslint",
      "Axios",
      "TailwindCSS",
      "Shadcn",
    ],
    category: "web app",
    github: null,
    href: "https://www.thecoterie.co/",
  },
  {
    id: 4,
    title: "Pamela Hudson Real Estate",
    date: null,
    description:
      "Pamela Hudson Real Estate is a boutique agency specializing in luxury properties across Northern California’s scenic coast. The firm is known for its personalized service, local expertise, and dedication to helping clients find their dream homes.",
    images: [
      "/assets/projects/pamela-hudson/hero1.png",
      "/assets/projects/pamela-hudson/hero2.png",
    ],
    tags: [
      "React Js",
      "Node Js",
      "Express Js",
      "GitHub",
      "Prettier",
      "Eslint",
      "Axios",
      "Bootstrap",
    ],
    category: "web app",
    github: null,
    href: "https://pamelahudson.net/",
  },
  {
    id: 5,
    title: "WorkerX",
    date: null,
    description:
      "WorkerX simplifies workforce management by offering streamlined solutions for task assignment, time tracking, and team coordination. Enhance productivity and manage your team effortlessly with WorkerX.",
    images: ["/assets/projects/workerx/WORKERX.png"],
    tags: ["React Js", "GitHub", "Prettier", "Eslint", "Axios", "AntDesign"],
    category: "web app",
    github: null,
    href: "https://workerx.vercel.app/",
  },
  {
    id: 6,
    title: "Get An Intervention",
    date: null,
    description:
      "Get An Intervention is your go-to platform for finding trusted and effective addiction intervention services. Whether you’re seeking help for yourself or a loved one, our platform connects you with professional interventionists who can guide you on the path to recovery. We provide a streamlined process to help you access the support you need, when you need it most. Start your journey to healing today with Get An Intervention.",
    images: ["/assets/projects/get-an-intervention/hero.png"],
    tags: ["HTML 5", "CSS 3", "GitHub", "Prettier", "Perfect Pixel Extension"],
    category: "web app",
    github: null,
    href: "https://get-an-intervention-dev.vercel.app/",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];

export const testimonials = [
  {
    id: 0,
    author: "Yusra Fatima",
    image: null,
    organization: "Onestream Live",
    quote: `I have worked with suleman on Optimisation project. Suleman is an exceptional developer who quickly understood the entire product in a remarkably short time. Within weeks, he began working on new features with impressive speed and efficiency. Despite the tight deadlines, he single-handedly developed several critical features, none of which have ever encountered failures.

Moreover, he made a detailed optimization report for the whole product providing critical details about the issues causing the lag in the app, which proved invaluable in helping other developers resolve issues and improve system performance. His technical contributions really helped in ensuring the stability of the project.`,
  },
  {
    id: 1,
    author: "Hamza Iqbal",
    image: null,
    organization: "Onestream Live",
    quote: `I had the opportunity of working with Muhammad Suleman in OneStream live. His technical ability is top-notch, and he is adept at solving complex problems while helping the team members along the way. He works seamlessly in a fast-paced environment, and his work quality is exceptional. Additionally, he mentors and guides others on best practices and new trends, showcasing his strong leadership qualities. His dedication would make him a valuable asset to any team he joins.`,
  },
  {
    id: 2,
    author: "Misha'el Mushtaq",
    image: null,
    organization: "Bitsol Technologies",
    quote: `During Suleman's tenure, he exhibited remarkable professionalism, being consistently punctual, respectful, and diligent in adhering to office policies. He actively contributed as a dedicated member of our Culture Committee, displaying enthusiasm and creativity. Muhammad Suleman, is not only a valuable asset due to his skills but also a pleasure to work with, embodying the qualities of a true professional and team player. I wholeheartedly recommend him for any endeavor.
Additionally, Muhammad Suleman possesses excellent interpersonal skills, fostering a positive and collaborative work environment. He consistently goes above and beyond to deliver exceptional results, making him an invaluable member of any team. Muhammad Suleman is not only an asset to the organization but also a true role model for dedication and professionalism.`,
  },
  {
    id: 3,
    author: "Rizwan Ahmed",
    image: null,
    organization: "Bitsol Technologies",
    quote: `I highly recommend Mr. Suleman as a Software Engineer. While I haven't been his direct supervisor, his work ethics and communication skills are commendable. He's proven to be an excellent team player and possesses strong technical skills. Suleman's contributions to any team are sure to be valuable.`,
  },
];
